import { getVehicle } from "../../api/UsedVehiclesAPI";
import axios from 'axios';
import { usedVehicleLockService } from "../../api/used-vehicle-locks/UsedVehicleLockService";
import normalizeQuote from "../../api/finance/NormalizeQuote";
/*jshint esversion: 6 */
/*jshint strict:false */

const getDefaultState = () => {
    return {
        error: false,
        type: '',
        vehicle: null,
        vehicleImage: null,
        locked: false,
        lockedByCustomer: false,
        lockedReason: '',
        lockedButReservable: false,
        lockedButApplyForFinancable: false,
        lockedButPurchasable: false,
        locksCustomerHasOnVehicle: [],
        vyneAvailable: false,
        autoconvertAvailable: false,

        step: 1,
        additionalProducts: [],
        collectionDate: {
            selected: false,
            date: false,
            time: false
        },
        status: false,
        marketing_preference: '',
        cancelModalOpen: false,
        codeweaversQuote: null,
        normalizedCodeweaversQuote: null,
        vyneReference: null,

        financeApplicationData: {
            numDependants: null,
            maritalStatus: null,
            driversLicenceType: null,
            dateOfBirthDay: null,
            dateOfBirthMonth: null,
            dateOfBirthYear: null,
            vehicleRequirementPrice: null,
            vehicleRequirementDeposit: null,
            vehicleRequirementBodyType: null,
            vehicleRequirementFuelType: null,
            // addresses: [{ editAddress: true }],
            addresses: [{ editAddress: true, data: { selectedAddressLookupObject: null, postcode: null, buildingNumber: null, street: null, county: null, town: null, residentialStatus: null, timeAtAddressYears: null, timeAtAddressMonths: null } }],
        },
        openingTimes:{}
    };
};

const state = getDefaultState();

const mutations = {
    toggleError(state) {
        state.error = !state.error;
    },
    setVehicle(state, vehicle) {
        state.vehicle = vehicle;
        state.vehicleImage = '/images/used/image-coming-soon.jpg';
        if (!vehicle) {
            return;
        }
        if (typeof vehicle.used_vehicles_internal_images == "undefined") {
            return;
        }
        if (typeof vehicle.used_vehicles_internal_images[0] == "undefined") {
            return;
        }
        if (typeof vehicle.used_vehicles_internal_images[0].thumbnail_path != "undefined") {
            state.vehicleImage = vehicle.used_vehicles_internal_images[0].thumbnail_path;
            return;
        }
        if (typeof vehicle.used_vehicles_internal_images[0].small_2x_jpg != "undefined") {
            state.vehicleImage = '/' + vehicle.used_vehicles_internal_images[0].small_2x_jpg;
            return;
        }
    },
    setVyneAvailable(state, vyneAvailable) {
        // state.vyneAvailable = (vyneAvailable == true) ? true : false;
        state.vyneAvailable = false;
    },
    setAutoconvertAvailable(state, autoconvertAvailable) {
        state.autoconvertAvailable = (autoconvertAvailable == true) ? true : false;
    },
    setVehicleImage(state, vehicleImage) {
        state.vehicleImage = vehicleImage;
    },
    setProducts(state, products) {
        let groupedProducts = {};
        // Add a selected state to each product object
        Object.keys(products).forEach(key => {
            const product = products[key];
            if (typeof groupedProducts[product.type] == 'undefined') {
                groupedProducts[product.type] = [];
            }
            groupedProducts[product.type].push({ ...product, selected: false });
        });

        state.additionalProducts = groupedProducts;
    },
    setProductsFromDb(state, products) {
        state.additionalProducts = products;
    },
    toggleProduct(state, { id, type }) {
        state.additionalProducts[type].forEach((product, index) => {
            if (product.id !== id) {
                state.additionalProducts[type][index].selected = false;
                return;
            }
            state.additionalProducts[type][index].selected = !product.selected;
        });
    },
    setProductsSelectedFromSession(state, selectedProducts) {
        Object.keys(selectedProducts).forEach(key => {
            selectedProducts[key].forEach(product => {
                const index = state.additionalProducts[key].findIndex(stateProduct => stateProduct.id === product.id);

                if (index >= 0) {
                    state.additionalProducts[key][index].selected = true;
                }
            });
        });
    },
    incrementStep(state) {
        state.step += 1;
    },
    decrementStep(state) {
        state.step -= 1;
    },
    setStep(state, step) {
        state.step = step;
    },
    setType(state, type) {
        state.type = type;
    },
    toggleCollection(state) {
        state.collectionDate.selected = !state.collectionDate.selected;
    },
    setCollectionDate(state, date) {
        state.collectionDate.date = date;
    },
    setCollectionTime(state, time) {
        state.collectionDate.time = time;
    },
    setCollectionDataFromSession(state, data) {
        state.collectionDate.date = data.date;
        state.collectionDate.time = data.time;

        if (state.collectionDate.date && state.collectionDate.time) {
            state.collectionDate.selected = true;
        }
    },
    setStatus(state, status) {
        state.status = status;
    },
    setMarketingPreference(state, preference) {
        state.marketing_preference = preference;
    },
    setCancelModalOpen(state, status) {
        state.cancelModalOpen = status;
    },
    resetState(state) {
        Object.assign(state, getDefaultState());
    },
    setCodeweaversQuote(state, quote) {
        state.codeweaversQuote = quote;
        if (typeof quote.Finance != 'undefined') {
            state.normalizedCodeweaversQuote = normalizeQuote(quote.Finance);
        } else {
            state.normalizedCodeweaversQuote = null;
        }
    },
    setVyneReference(state, reference) {
        state.vyneReference = reference;
    },
    resetVehicleLock(state) {
        state.locked = false;
        state.lockedByCustomer = false;
        state.lockedReason = '';
        state.lockedButReservable = false;
        state.lockedButApplyForFinancable = false;
        state.lockedButPurchasable = false;
        state.locksCustomerHasOnVehicle = [];
    },
    setVehicleLocked(state, isLocked) {
        state.locked = isLocked;
    },
    setVehicleLockedByCustomer(state, lockedByCustomer) {
        state.lockedByCustomer = lockedByCustomer;
    },
    setVehicleLockedReason(state, lockedReason) {
        state.lockedReason = lockedReason;
    },
    setVehicleLockedButReservable(state, lockedButReservable) {
        state.lockedButReservable = lockedButReservable;
    },
    setVehicleLockedButApplyForFinancable(state, lockedButApplyForFinancable) {
        state.lockedButApplyForFinancable = lockedButApplyForFinancable;
    },
    setVehicleLockedButPurchasable(state, lockedButPurchasable) {
        state.lockedButPurchasable = lockedButPurchasable;
    },
    setLocksCustomerHasOnVehicle(state, locksCustomerHasOnVehicle) {
        const validLocks = [];
        Object.keys(locksCustomerHasOnVehicle).forEach(index => {
            const lock = locksCustomerHasOnVehicle[index];
            if (lock.sourceable_type == 'RobinsAndDay\\Models\\AutoConvert\\AutoConvertApplication') {
                validLocks.push({
                    type: 'finance',
                    unlocks_at: lock.unlocks_at
                });
                return;
            }
            if (lock.sourceable_type == 'RobinsAndDay\\Reservation') {
                validLocks.push({
                    type: 'reservation',
                    unlocks_at: lock.unlocks_at
                });
                return;
            }
            if (lock.sourceable_type == 'RobinsAndDay\\Models\\UsedVehicle\\VynePaymentRecord') {
                validLocks.push({
                    type: 'purchase',
                    unlocks_at: lock.unlocks_at
                });
                return;
            }
        })
        state.locksCustomerHasOnVehicle = validLocks;
    },
    setFinanceApplicationDataItem(state, options) {
        if (typeof options !== 'object') {
            return false;
        }

        Object.keys(options).forEach((key) => {
            if (typeof state.financeApplicationData[key] == 'undefined') {
                return;
            }

            state.financeApplicationData[key] = options[key];
        });
    },
    setOpeningTimes(state, openingTimes) {
        state.openingTimes = openingTimes
    },
};

const actions = {
    setVehicleFromTemporaryModel({ commit, dispatch }, temporaryModel) {
        try {
            const vehicleData = JSON.parse(temporaryModel.json);
            if (temporaryModel.temporary_model_images && temporaryModel.temporary_model_images.length > 0) {
                vehicleData.used_vehicles_internal_images = temporaryModel.temporary_model_images;
            }
            if (temporaryModel.reservation_fee && temporaryModel.reservation_fee > 0) {
                vehicleData.reservation_fee = temporaryModel.reservation_fee;
            } else {
                vehicleData.reservation_fee = 99;
            }
            commit("setVehicle", vehicleData);
        } catch (error) {
            console.error("Error decoding temporary model", error);
        }
    },
    getAdditionalProducts({ dispatch, commit, state }) {
        return new Promise((resolve, reject) => {
            axios
                .get(`/api/buy-online/${state.vehicle.id}/products`, {
                    headers: {
                        Accept: "application/json",
                    },
                })
                .then((response) => {
                    commit("setProducts", response.data);
                    dispatch("setProductsSelectedFromSession");
                    resolve(response.data);
                })
                .catch(error => {
                    console.error(error);
                    commit("toggleError");
                    reject(error);
                });
        });
    },
    checkIfVehicleIsStillPurchaseable({ commit, state }, getLocktypeAndExpiry = false) {
        return new Promise((resolve, reject) => {
            // If it's locked, do a check to see if we have a potential unlock reference in local storage
            const vehicleIdToGetLockFor = state.vehicle.id;
            const potentialLock = usedVehicleLockService.getStoredLock(vehicleIdToGetLockFor);

            axios
                .get("/api/used-vehicle-lock/" + vehicleIdToGetLockFor, {
                    params: {
                        ref: potentialLock,
                        getLocktypeAndExpiry: getLocktypeAndExpiry,
                    },
                })
                .then(response => {
                    commit('setVehicleLocked', response.data.locked);
                    commit('setVehicleLockedByCustomer', response.data.locked_by_customer);
                    commit('setVehicleLockedReason', response.data.reason);
                    commit('setVehicleLockedButReservable', response.data.allows_reservation);
                    commit('setVehicleLockedButApplyForFinancable', response.data.allows_finance);
                    commit('setVehicleLockedButPurchasable', response.data.allows_purchase);
                    if (response.data.locks) {
                        commit('setLocksCustomerHasOnVehicle', response.data.locks);
                    } else {
                        commit('setLocksCustomerHasOnVehicle', []);
                    }
                    resolve();
                })
                .catch(error => {
                    console.error("Error checking vehicle lock status", error);
                    reject(error)
                });
        });
    },
    cancelPaymentRecord({ commit, state }) {
        return new Promise((resolve, reject) => {
            if (!state.vehicle || !state.vehicle.id) {
                reject(new Error('No vehicle is set'));
                return;
            }
            if (!state.vyneReference) {
                reject(new Error('Vyne reference is empty'));
                return;
            }

            axios({
                method: "DELETE",
                url: `/api/vyne/${state.vyneReference}`,
                headers: {
                    Accept: "application/json",
                },
                data: {
                    id: state.vehicle.id
                }
            })
                .then((response) => {
                    getVehicle(state.vehicle.id)
                        .then(vehicle => {
                            commit('setVehicle', vehicle);
                            if (response.data.deleted) {
                                commit('setVyneReference', null);
                                resolve(true);
                                return;
                            }
                            resolve(false);
                        })
                        .catch(error => {
                            console.error("Vuex BuyOnline/loadVehicleIfNecessary error", error);
                            commit('setVehicle', null);
                            commit("toggleError");
                            reject(err);
                        });
                })
                .catch((err) => {
                    commit("toggleError");
                    reject(err);
                });
        })
    },
    loadCodewaversQuoteIfNecessary({ commit, state }, quoteReference) {
        return new Promise((resolve, reject) => {
            if (state.codeweaversQuote != null && state.codeweaversQuote.Finance.Quote.QuoteReference == quoteReference) {
                resolve(state.codeweaversQuote);
                return;
            }

            axios({
                method: "GET",
                url: "https://services.codeweavers.net/api/finance/quote/" + quoteReference,
                headers: {
                    "X-CW-ApiKey": "ONH75GHd8x0gu6yfJ6",
                    "Access-Control-Allow-Origin": "*",
                    "Content-Type": "application/json",
                },
            })
                .then(response => {
                    commit('setCodeweaversQuote', response.data);
                    resolve(response.data);
                })
                .catch(error => {
                    console.error("Vuex BuyOnline/loadCodewaversQuoteIfNecessary error", error, error.response);
                    reject(error);
                });

        });
    },
    loadVehicleIfNecessary({ commit, state, dispatch }, vehicleId) {
        return new Promise((resolve, reject) => {
            if (state.vehicle != null && state.vehicle.id == vehicleId) {
                dispatch('checkIfVehicleIsStillPurchaseable');
                resolve(state.vehicle);
                return;
            }

            commit('resetVehicleLock');

            getVehicle(vehicleId)
                .then(vehicle => {
                    commit('setVehicle', vehicle);
                    // commit('setVyneAvailable', vehicle.location.accepts_vyne_payment);
                    commit('setVyneAvailable', false);
                    commit('setAutoconvertAvailable', vehicle.location.has_autoconvert);
                    resolve(vehicle);
                    dispatch('checkIfVehicleIsStillPurchaseable');
                })
                .catch(error => {
                    console.error("Vuex BuyOnline/loadVehicleIfNecessary error", error);
                    commit('setVehicle', null);
                    commit('setVyneAvailable', false);
                    commit('setAutoconvertAvailable', false);
                    reject(error);
                })
        });
    },
    setVehicle({ commit }, vehicle) {
        commit('setVehicle', vehicle);
    },
    previousStep({ commit }) {
        commit('decrementStep');
    },
    setStep({ commit }, step) {
        commit('setStep', step);
    },
    selectPayToday({ commit }) {
        commit('setType', 'paynow');
        commit('incrementStep');
    },
    toggleProductSelected({ commit, getters }, data) {
        commit('toggleProduct', data);
        sessionStorage.setItem('selectedProducts', JSON.stringify(getters.selectedProducts));
    },
    setProductsSelectedFromSession({ commit, state }) {
        if (state.initialized) {
            return;
        }
        if (typeof sessionStorage == 'undefined') {
            return;
        }
        let selectedProducts = sessionStorage.getItem('selectedProducts');
        if (selectedProducts == '' || selectedProducts == null) {
            return;
        }
        selectedProducts = JSON.parse(selectedProducts);
        commit('setProductsSelectedFromSession', selectedProducts);
    },
    toggleCollection({ commit }) {
        commit('toggleCollection');
    },
    setCollectionDate({ commit, getters }, date) {
        commit('setCollectionDate', date);
        sessionStorage.setItem('collectionData', JSON.stringify(getters.collectionDetails));
    },
    setCollectionTime({ commit, getters }, time) {
        commit('setCollectionTime', time);
        sessionStorage.setItem('collectionData', JSON.stringify(getters.collectionDetails));
    },
    setCollectionDataFromSession({ commit, state }) {
        if (state.initialized) {
            return;
        }
        if (typeof sessionStorage == 'undefined') {
            return;
        }
        let collectionData = sessionStorage.getItem('collectionData');
        if (collectionData == '' || collectionData == null) {
            return;
        }
        collectionData = JSON.parse(collectionData);
        commit('setCollectionDataFromSession', collectionData);
    },
    setStatus({ commit }, status) {
        commit('setStatus', status);
    },
    setMarketingPreference({ commit }, preference) {
        commit('setMarketingPreference', preference);
        sessionStorage.setItem('marketingPreference', JSON.stringify(preference));
    },
    setMarketingPreferenceFromSession({ commit, state }) {
        if (state.initialized) {
            return;
        }
        if (typeof sessionStorage == 'undefined') {
            return;
        }
        let marketingPreference = sessionStorage.getItem('marketingPreference');
        if (marketingPreference == '' || marketingPreference == null) {
            return;
        }
        marketingPreference = JSON.parse(marketingPreference);
        commit('setMarketingPreference', marketingPreference);
    },
    setType({ commit }, type) {
        commit('setType', type);
    },
    setStateForPurchaseRetry({ commit, dispatch }) {
        commit('setStep', 5);
        commit('setType', 'paynow');
        commit('setStatus', false);
        dispatch('setCollectionDataFromSession');
        dispatch('setMarketingPreferenceFromSession');
    },
    getOpeningTimes({ dispatch, commit, state }) {
        return new Promise((resolve, reject) => {
            axios
                .get(`/api/dealer-opening-times-array`, {
                    params: {
                            locationId: state.vehicle.location_id,
                        },
                        headers: {
                            Accept: "application/json",
                        },
                })
                .then((response) => {
                    commit("setOpeningTimes", response.data);
                    resolve(response.data);
                })
                .catch(error => {
                    console.error(error);
                    commit("toggleError");
                    reject(error);
                });
        });
    },
    resetState({ commit }) {
        commit('resetState');
    },
};

const getters = {
    locationId(state) {
        return state.vehicle.location_id || 0;
    },

    collectionDetailsSet(state) {
        return state.collectionDate.date !== false && state.collectionDate.time !== false;
    },

    collectionDetails(state) {
        return {
            date: state.collectionDate.date ? new Date(state.collectionDate.date).toDateString() : '',
            time: state.collectionDate.time
        };
    },

    purchaseTotal(state, getters) {
        let basePrice = parseFloat(state.vehicle.price);

        Object.keys(getters.selectedProducts).forEach(key => {
            basePrice += getters.selectedProducts[key].reduce((acc, curr) => acc + parseFloat(curr.price), 0);
        });

        return basePrice;
    },

    purchaseStatus(state) {
        return state.status;
    },

    selectedProducts(state) {
        let original = {};
        Object.keys(state.additionalProducts).forEach(key => {
            original = {
                ...original,
                [key]: [...state.additionalProducts[key].filter(product => product.selected)]
            };
        });

        return original;
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};